import type { TableCommandFactory } from 'components/Table/model/TableModel';

interface ChangeTableSettingsVisibilityCommand {
  value: boolean;
}

export const changeTableSettingsVisibility: TableCommandFactory<
  ChangeTableSettingsVisibilityCommand
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    draft.openSettings = command.value;
  });
};
